import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "viewExchangeLog" }
const _hoisted_2 = { class: "text-sm-start" }

import { ElButton } from "element-plus";
import { ref } from "vue";
import i18n from "@/core/i18n/i18n";
import PopupWindow from "@/core/popup/components/PopupWindow.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewExchangeLog',
  props: {
    dialog: { type: Boolean },
    moved: { type: Boolean },
    stoppable: { type: Boolean },
    exchangeLogContent: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const props = __props;

const inner = ref<HTMLElement>();

const emit = __emit;

async function close() {
  emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PopupWindow, {
      dialog: _ctx.dialog,
      size: "sm",
      live: 0,
      fixed: false,
      moved: _ctx.moved,
      lazyLoad: false,
      "fixed-height": false,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
    }, {
      "header-label": _withCtx(() => [
        _createTextVNode(" Exchange Logs ")
      ]),
      main: _withCtx(() => [
        _createElementVNode("div", {
          ref_key: "inner",
          ref: inner
        }, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.exchangeLogContent), 1)
        ], 512)
      ]),
      footer: _withCtx(() => [
        (_ctx.stoppable)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              class: "btn-oneTeg2",
              onClick: close
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("Common.Close")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dialog", "moved"])
  ], 512))
}
}

})